module.exports = __webpack_public_path__ + "static/media/bg.1104955b.png";